// React
import React, { useState, useEffect } from "react";
// React
// CSS
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
// CSS
// Components
import { useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
//
import PushNotification from "./Components/PushNotification/PushNotification";
import Footer from "./Components/Footer/Footer";
// Components
// Models
import { I_AllDataNeeded, I_QuizMakerQuestions } from "./Models/interfaces";
// Models
// Containers
import MasterWarper from "./Containers/MasterWarper/MasterWarper";
import Router from "./Router/Router";
// Containers

const App = () => {
  // ***************************States****************************************
  const [isNeedFullScreen, setIsNeedFullScreen] = useState<boolean>(false);
  console.log(isNeedFullScreen);
  //
  const [userToken, setUserToken] = useState<string>(
    JSON.parse(
      localStorage.getItem("amoozeshMeliToken") || JSON.stringify("init")
    )
  );
  //
  const [userQuestions, setUserQuestions] = useState<I_QuizMakerQuestions[]>(
    []
  );

  const [lessonData, setLessonData] = useState<{
    teacherId: number | string;
    subjectId: number | string;
    lessonId: string | number;
    lessonName: string;
  }>({
    teacherId: 0,
    lessonId: 0,
    subjectId: 0,
    lessonName: "",
  });
  const [allNeededData, setAllNeededData] = useState<I_AllDataNeeded>({
    teacherId: "",
    teacherName: "",
    subjectId: "",
    lessonId: "",
    lessonName: "",
    sectionName: "",
    lessonPictureUrl: "",
  });
  // ***************************States****************************************
  // *************************************************************************
  // *************************************************************************
  // ***************************Constants*************************************
  const navigate = useNavigate();
  const location = useLocation();
  // ***************************Constants*************************************
  // *************************************************************************
  // *************************************************************************
  // ***************************Life Cycles***********************************
  useEffect(() => {
    if (userToken === "init") {
      navigate("/otp");
      return;
    }
  }, [userToken, navigate]);
  //
  // useEffect(() => {
  //   // console.log(userQuestions);
  // }, [userQuestions]);

  // ***************************Life Cycles***********************************

  return (
    <>
      <PushNotification />
      <ToastContainer
        position={window.innerWidth > 600 ? "top-center" : "top-left"}
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          width: "100vw",
          right: "0vw",
          height: "4vh",
          marginTop: "1vh",
        }}
      />

      <MasterWarper
        setUserQuestions={setUserQuestions}
        userQuestions={userQuestions}
        userToken={userToken}
        setLessonData={setLessonData}
        lessonData={lessonData}
        allNeededData={allNeededData}
        setAllNeededData={setAllNeededData}
      >
        <Router
          setIsNeedFullScreen={setIsNeedFullScreen}
          setUserQuestions={setUserQuestions}
          setUserToken={setUserToken}
          userQuestions={userQuestions}
          userToken={userToken}
        />
      </MasterWarper>
      {/* 
      {isNeedFullScreen ? (
        <></>
      ) : ( */}
      <>
        {!location.pathname.includes("otp") ? (
          <>
            <Footer />
          </>
        ) : null}
      </>
      {/* )} */}
    </>
  );
};

export default App;
